import React, { useContext, useState } from "react";

import { Grid, Grow } from "@material-ui/core";
import { Header } from "../styles/Emissao";

import BigDataTable from "../../../../components/tables/BigDataTable";
import { QueryParamsContext } from "../../../../context/QueryParamsContext";
import Chip from "../../../../components/basics/Chip";
import Btn from "../../../../components/buttons/Btn";
import useNfeController from "../controllers/NfeController";

const TabHistoricoInutilizacao = ({ ...props }) => {
  const { handleResendInutilization } = useNfeController();

  const { queryParams } = useContext(QueryParamsContext);

  // eslint-disable-next-line
  const [queryHistory, setQueryHistory] = useState({
    idempresa: queryParams.id,
  });
  // eslint-disable-next-line
  const [queryOrderBy, setQueryOrderBy] = useState("-created_at,series_id");

  const columnsHistory = [
    {
      label: "Número",
      id: "numero",
    },
    {
      label: "Série",
      format: (item) => {
        return `${item.series.numero_serie}`;
      },
    },
    {
      label: "Motivo",
      id: "motivo",
    },
    {
      label: "Protocolo",
      id: "protocolo",
    },
    {
      label: "Data/Hora",
      id: "datahora",
    },
    {
      label: "",
      format: (item) => {
        return item?.created_at && !item?.protocolo ? (
          <Btn
            label="Reenviar"
            bgcolor="primary"
            onClick={() => {
              handleResendInutilization(item);
            }}
          />
        ) : (
          <></>
        );
      },
    },
  ];

  return (
    <Grow in={true}>
      <Grid container spacing={3} key="tab-historico-inutilizacao">
        <Grid item xs>
          <BigDataTable
            tableTitle={
              <Header>
                <Grid container spacing={2}>
                  <Grid item sm>
                    <Chip label="Números Inutilizados" bgcolor="secondary" />
                  </Grid>
                </Grid>
              </Header>
            }
            route="nf/numerosinutilizados/v1"
            where={queryHistory}
            fixedSort={queryOrderBy}
            columns={columnsHistory}
            include="series"
          />
        </Grid>
      </Grid>
    </Grow>
  );
};

export default TabHistoricoInutilizacao;
